import { useQuery } from '@tanstack/react-query';
import type { MotornetAutosuggestResponse } from '../types';
import { MIN_MANUFACTURE_CODE_LENGTH } from '../types';
import { useApiClient } from 'src/hooks/useApiClient';

export { MIN_MANUFACTURE_CODE_LENGTH };

interface UseVehicleAutosuggestOptions {
	enabled?: boolean;
	staleTime?: number;
	gcTime?: number;
}

export const useVehicleAutosuggest = (
	manufactureCode: string,
	{
		enabled = true,
		staleTime = 5 * 60 * 1000,
		gcTime,
	}: UseVehicleAutosuggestOptions = {}
) => {
	const { apiClient } = useApiClient();

	const code = manufactureCode.trim();

	return useQuery<MotornetAutosuggestResponse>({
		queryKey: ['motornet', 'autosuggest', code],
		enabled: enabled && code.length >= MIN_MANUFACTURE_CODE_LENGTH,
		queryFn: () =>
			apiClient.motornetControllerService.getVehicleAutosuggestByManufactureCode(
				code
			),
		staleTime,
		gcTime,
		retry: false,
		refetchOnWindowFocus: false,
	});
};
